import { useMemo } from "react";

const useLiveTheArt = (banners = []) => {
  // banners is now directly an array from API
  const { leftImage, rightImage } = useMemo(() => {
    return {
      leftImage: banners.find((img) => img.sequence === 1)?.media,
      rightImage: banners.find((img) => img.sequence === 2)?.media,
    };
  }, [banners]);

  return { leftImage, rightImage };
};

export default useLiveTheArt;